import NoRolesScreenForm from 'components/modules/auth/NoRolesScreenForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

const NoRolesScreen = () => {
  return (
    <AuthCardLayout logo={true}>
      <NoRolesScreenForm />
    </AuthCardLayout>
  );
};

export default NoRolesScreen;
